import $ from 'jquery';

$(function(){
    $('.program-selector-btn').click(function(){
       setCookie('X-PROGRAM', $(this).data().program,10 );
        window.location.href = $(this).data().href;
      });

});

$.fn.extend({
  donetyping: function(callback,timeout){
    timeout = timeout || 1e3;
    let timeoutReference,
        doneTyping = function(el,e){
          if (!timeoutReference) return;
          timeoutReference = null;
          callback(el,e);
        };
    return this.each(function(i,el){
      let $el = $(el);
      $el.is(":input") &&
        $el
          .on("input", function (e) {
            if (e.type == "keyup" && e.keyCode != 8) return;
            if (timeoutReference) clearTimeout(timeoutReference);
            timeoutReference = setTimeout(function () {
              doneTyping(el, e);
            }, timeout);
          })
          .on("blur", function (e) {
            doneTyping(el, e);
          });
    });
  }
});

function setCookie(cname, cvalue, exdays) {
  let d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  let expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + "; " + expires + "; path=/";
}
function handleOutboundLinkClicks(event,category) {
  ga('send', 'event', {
    eventCategory: category,
    eventAction: 'click',
    eventLabel: event.target.href
  });
}
function getCookie(cname) {
  let name = cname + "=";
  let ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') c = c.substring(1);
    if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
  }
  return "";
}

function request(cfg) {
  cfg.data = cfg.data || {};
  cfg.headers = cfg.headers || {};

  let headers = cfg.headers;
  headers["X-TIMEZONE"] = Intl.DateTimeFormat().resolvedOptions().timeZone;
  if(cfg.headers.gRecaptcha && cfg.headers.gRecaptcha.length>1) {
    headers["X-RECAPTCHA-RESPONSE"] = cfg.headers.gRecaptcha||'';
  }


  $.ajax({
    type: cfg.method || 'GET',
    url: cfg.url,
    dataType: cfg.dataType === undefined ? undefined : cfg.dataType,
    contentType: cfg.contentType === undefined ? undefined : cfg.contentType,
    data: cfg.data,
    headers: headers,
    processData: cfg.processData === undefined ? undefined : cfg.contentType,
    xhr: cfg.xhr,
    traditional:true,
    success: function (r) {
      if (cfg.loadingEl) cfg.loadingEl.removeClass('loading-mask');

      if (r.errorCode) {
        if (!cfg.preventDefaultError) onError(r.message);
        cfg.onError && cfg.onError(r.responseJSON);
      } else {
        if (typeof cfg.callback == 'function') {
          cfg.callback.call(this, r); // r.data
        }
      }
    },
    error: function (r) {
      if(r.status === 401){
        onError(`Request Denied (Session Expired) <br><br><a class="btn btn-primary" href="/session-logout">Log In</a>`,true);
        return;
      }
      let responseObject = null;
      try {
        responseObject = JSON.parse(r.responseText || '{}');
      } catch(e) {
        // do nothing
      }

      if (cfg.loadingEl) cfg.loadingEl.removeClass('loading-mask');

      if (!cfg.preventDefaultError) {
        let response, serverMessage;
        try {
          response = JSON.parse(responseObject);
        } catch(e) {
          // do nothing
        }

        if(response && response[0] && response[0].message) {
          serverMessage = response[0].message;
        }

        if(!serverMessage) {
          let ts = new Date().getTime() + new Date().getTimezoneOffset() * 60000;
          serverMessage = "An error occurred, please try again later.<br><br>" +
            "<small style='word-break: break-all'>URL: " + cfg.url + "<br>" +
            "Params: " + JSON.stringify(cfg.data || {}) + "<br>"/* +
          "Time: " + (new Date(ts).format('Y-m-d H:i:s')) + "</small>"*/;
        }

        onError(serverMessage);
      }

      if(cfg.onError) cfg.onError(responseObject);
    }
  })
}

function onError(errorMessage,classicalModal) {
  if(!classicalModal) classicalModal=false;
  setTimeout(function () {
    Modal.show({
      html: errorMessage || "An error occurred, please try again later",
      withoutYes: true,
      classicalModal:classicalModal
    })
  }, 500)
}

function getParam(key) {
  let result = false,
      tmp = [];
  let items = location.search.substr(1).split("&");
  for (let index = 0; index < items.length; index++) {
    tmp = items[index].split("=");
    if (tmp[0] === key) result = decodeURIComponent(tmp[1]);
  }
  return result;
}

let Validation = {
  displayError: function (id, error) {
    if(id==='alert')
      Modal.show({
        html: error,
        withoutYes: true,
        no: 'Close',
        type: 'warning'
      });
    else {
    let field = $('#' + id);
    if (field.length) {
      field.closest('.form-group').addClass('has-error').find('.help-block.with-errors').text(error || 'Invalid input');
    }
    }
  },
  clear: function (id) {
    let field = $('#' + id);
    if (field.length) {
      field.closest('.form-group').removeClass('has-error').find('.help-block.with-errors').text('');
    }
  },
  customRules: {
    custom: {
      password: function ($el) {
        let matchValue = $el.data("password") // foo
        if (matchValue === 'strong') {
          let v = $el.val();
          if (!v || v.length < 6 || !v.match(/[A-Z]/) || !v.match(/[0-9]/) || !v.match(/[^a-zA-Z0-9]/)) {
            return "Password must contain an uppercase letter, a numeric character, a special character and must be at least 6 characters long";
          }
        }
      },
      email: function ($el) {
        let matchValue = $el.data("email") // foo
        if (matchValue === 'strong') {
          let v = $el.val();
          if (!v  || !v.match(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/)) {
            return "Email is not correct";
          }
        }
      }
    }
  },
  multipleFields:function (fields) {
   $.each(fields,function(i,field){
       $(field).closest('.form-group').addClass('has-error').find('.help-block.with-errors').text( 'Invalid input');
   })
  }
};

let storeValidation={
  custom: {
    available: function ($el) {
      let matchValue = $el.data().available;
      let description = $el.data().fullInfo.description;
      if (!matchValue) {
        return description;
      }
    }
  }
}

let storeValidation2 = {
  custom: {
    value: function ($el) {
      let matchValue = $el.data().value;
      if (!matchValue) {
        return "Please select store";
      }
    }
  }
}

let emailValidation= {
  custom: {
    email: function ($el) {
      let matchValue = $el.data("email")
      if (matchValue === 'strong') {
        let v = $el.val();
        if (!v  || !v.match(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/)) {
          return "Email is not correct";
        }
      }
    }
  }
}

function createSuggestor(cfg) {
  cfg.input.donetyping(function (el,e) {
    let code = e.which || e.keyCode;

    if(code === 40) { // Down
      return select('down');
    } else if(code === 38) { // Up
      return select('up');
    } else if(code === 13) {
      return enter();
    }

    onChange();

    e.stopPropagation();
  },500);

  cfg.input.focus(function (e) {
    onChange();

    e.stopPropagation();
  });

  cfg.input.click(function (e) {
    e.stopPropagation();
  });

  cfg.suggester.click(function (e) {
    e.stopPropagation();
  });

  $(document).click(function () {
    cfg.suggester.hide();
  });

  function onChange() {
    if(cfg.dataProvider) {
      cfg.dataProvider(cfg.input.val(), loadData);
    } else {
      request({
        url: cfg.url.replace(/\{str\}/, encodeURIComponent(cfg.input.val())),
        method: 'GET',
        preventDefaultError: true,
        data: {},
        callback: loadData
      });
    }
  }

  function loadData(items) {
    cfg.beforeLoad && cfg.beforeLoad();

    cfg.suggester.children().remove();
    $.each(items, function (k, item) {
     if (cfg.buildItem(item))
       cfg.suggester.append(
         cfg
           .buildItem(item)
           .addClass("item")
           .on("click touchend", function (e) {
             cfg.suggester.children().removeClass("selected");
             $(this).addClass("selected");
             enter();
           }),
       );

    });
    if(cfg.unbindClick) $(cfg.unbindClick).unbind('click');
    if(items.length) {
      cfg.suggester.show();
    } else {
      cfg.suggester.hide();
    }

    cfg.afterLoad && cfg.afterLoad(items);
  }

  function select(dir) {
    if(!cfg.suggester.children().length) return;
    let selection = cfg.suggester.find('.selected');
    if(selection.length) {
      let next = dir === 'down' ? selection.next('.item') : selection.prev('.item');
      if(next.length) {
        selection.removeClass('selected');
        next.addClass('selected');

        let selectionTop = cfg.suggester.scrollTop() + next.position().top;
        if(dir === 'down') {
          if(selectionTop + next.outerHeight() > cfg.suggester.scrollTop() + cfg.suggester.outerHeight()) {
            // If selected element is out of range
            cfg.suggester.scrollTop(selectionTop - cfg.suggester.outerHeight() + next.outerHeight());
          }
        } else {
          if(selectionTop < cfg.suggester.scrollTop()) {
            // If selected element is out of range
            cfg.suggester.scrollTop(selectionTop);
          }
        }
      }
    } else {
      cfg.suggester.find('.item').eq(0).addClass('selected');
    }
  }

  function enter() {
    if(!cfg.suggester.children().length) return;

    let selection = cfg.suggester.find('.selected');
    if(selection.length) {
      cfg.onSelect(selection, cfg.input);
      selection.removeClass('selected');
      cfg.suggester.hide();
    }
  }
  return {
    onChange:onChange
  }
}
function fillOrganizationEditForm(organization) {
  $('.organization-update-form')[0].reset()
  $('.organization-update-form input[name="org_type"][value="single_chapter"]')
    .prop({ checked: true })
    .trigger('change');
  if($('.organization-update-form input[name="guestId"]').length<1) $('.organization-update-form').prepend($('<input>').attr({type:'hidden',value:organization.guestId,name:'guestId'}));
  else $('.organization-update-form input[name="guestId"]').val(organization.guestId);

  $('.organization-update-form input[name="name"]').val(organization.name);
  $('.organization-update-form textarea[name="description"]').val(organization.description);

  $('.organization-update-form input[name="firstName"]').val(organization.firstName);
  $('.organization-update-form input[name="lastName"]').val(organization.lastName);
  $('.organization-update-form input[name="phone"]').val(organization.phone);
  $('.organization-update-form input[name="phoneExt"]').val(organization.phoneExt);
  $('.organization-update-form input[name="email"]').val(organization.email);
  $('.organization-update-form').data({validAdderss:organization.chapters?organization.chapters[0].uspsValidated:organization.uspsValidated});
  $('.organization-update-form input[name="paymentPayableTo"]').val(organization.chapters?organization.chapters[0].paymentPayableTo:organization.paymentPayableTo );
  $('.organization-update-form input[name="paymentInCareOf"]').val(organization.chapters?organization.chapters[0].paymentInCareOf:organization.paymentInCareOf  );
  $('.organization-update-form input[name="taxIdNumber"]').val(organization.chapters?organization.chapters[0].taxIdNumber:organization.taxIdNumber );
  $('.organization-update-form input[name="emailAddressForCheck"]').val(organization.chapters?organization.chapters[0].emailAddressForCheck:organization.emailAddressForCheck );
  $('.organization-update-form input[name="emailAddress2ForCheck"]').val( organization.chapters?organization.chapters[0].emailAddress2ForCheck:organization.emailAddress2ForCheck );
  // $('.organization-update-form input[name="emailAddressForCheck"]').data().value = organization.emailAddressForCheck;
  $('.organization-update-form input[name="city"]').val( organization.chapters?organization.chapters[0].city:organization.city );

  $('.organization-update-form input[name="residentialFistName"]').val(organization.chapters?organization.chapters[0].residentialFistName:organization.residentialFistName );
  $('.organization-update-form input[name="residentialLastName"]').val(organization.chapters?organization.chapters[0].residentialLastName:organization.residentialLastName );
  $('.organization-update-form select[name="residentialAddress"]').val(organization.chapters?organization.chapters[0].residentialAddress:organization.residentialAddress ? 'yes' : 'no').trigger('change');
  //$('.organization-update-form input[name="stateCode"]').val(organization.stateCode);
  let nonProfit = '';
  if(organization.nonProfit === true) nonProfit='yes';
  else if(organization.nonProfit=== false) nonProfit='no';
  $('.organization-update-form select[name="nonProfit"]').val(nonProfit)
  $('.organization-update-form input[name="charityStatusVerified"]').prop({checked:organization.chapters?organization.chapters[0].charityStatusVerified:organization.charityStatusVerified}).closest('div.row').removeClass('d-none');
  setupZipValidation(
    $('.organization-update-form select[name="stateCode"]'),
    $('.organization-update-form input[name="zipCode"]')
  );
  $('.organization-update-form #org-name-note').removeClass('with-errors');
  $('form.organization-update-form input[name="name"]').unbind('change keyup').bind('change keyup', function(){
    ($(this).val().length>100) && $('.organization-update-form #org-name-note').addClass('with-errors');
  })


  request({
    url: '/fundraisers/organizations/states',
    callback: function (states) {
      $('.organization-update-form select[name="stateCode"] option').remove();
      $.each(states, function (k, state) {
        $('.organization-update-form select[name="stateCode"]').append(
          $('<option>').attr({value: state.code}).text(state.name).data({state: state, country: state.country})
        );
      });
      $('.organization-update-form select[name="stateCode"]').val(organization.stateCode).trigger('change');
    }
  });

  $('.organization-update-form input[name="id"]').val(organization.id);
  $('.organization-update-form input[name="uuid"]').val(organization.uuid);
  $('.organization-update-form input[name="zipCode"]').val(organization.chapters?organization.chapters[0].zipCode:organization.zipCode );

  $('.organization-update-form .add-new-organization-btn').hide();
  $('.organization-update-form .add-new-event-btn').hide();
  $('.organization-update-form .organization-avatar-fields').hide();
  $('.organization-update-form').validator('validate');
  $('.organization-update-form').removeClass('loading-mask');
  $('.organization-update-form').unbind('change').find('input[name="emailAddressForCheck"], input[name="emailAddress2ForCheck"] ,input[name="city"] ,input[name="zipCode"],select[name="stateCode"]').change(function () {
    $('form.organization-update-form').data({validAdderss: false});
  });
}
function fillVfrOganizationEditForm(organization) {
  $('.organization-update-form')[0].reset()
  if($('.organization-update-form input[name="guestId"]').length<1) $('.organization-update-form').prepend($('<input>').attr({type:'hidden',value:organization.guestId,name:'guestId'}));
  else $('.organization-update-form input[name="guestId"]').val(organization.guestId);
  $('.organization-update-form input[name="name"]').val((organization.active) ? organization.name : organization.name + " ( "+organization.statusName +" )" );
  $('.organization-update-form textarea[name="description"]').val(organization.description);

  $('.organization-update-form').data({validAdderss: organization.uspsValidated});
  $('.organization-update-form input[name="firstName"]').val(organization.firstName);
  $('.organization-update-form input[name="lastName"]').val(organization.lastName);
  $('.organization-update-form input[name="phone"]').val(organization.phone);
  $('.organization-update-form input[name="phoneExt"]').val(organization.phoneExt);
  $('.organization-update-form input[name="email"]').val(organization.email);

  $('.organization-update-form input[name="residentialFistName"]').val(organization.residentialFistName);
  $('.organization-update-form input[name="residentialLastName"]').val(organization.residentialLastName);
  $('.organization-update-form select[name="residentialAddress"]').val(organization.residentialAddress ? 'yes' : 'no').trigger('change');

  $('.organization-update-form input[name="paymentPayableTo"]').val(organization.paymentPayableTo);
  $('.organization-update-form input[name="paymentInCareOf"]').val(organization.paymentInCareOf);
  $('.organization-update-form input[name="taxIdNumber"]').val(organization.taxIdNumber);
  $('.organization-update-form input[name="emailAddressForCheck"]').val(organization.emailAddressForCheck);
  $('.organization-update-form input[name="emailAddress2ForCheck"]').val(organization.emailAddress2ForCheck);
 // $('.organization-update-form input[name="emailAddressForCheck"]').data().value = organization.emailAddressForCheck;
  $('.organization-update-form input[name="city"]').val(organization.city);
  //$('.organization-update-form input[name="stateCode"]').val(organization.stateCode);
  $('.organization-update-form input[name="charityStatusVerified"]').prop({checked:organization.charityStatusVerified}).closest('div.row').removeClass('d-none')

  let nonProfit = '';
  if(organization.nonProfit === true) nonProfit='yes';
  else if(organization.nonProfit=== false) nonProfit='no';
  $('.organization-update-form select[name="nonProfit"]').val(nonProfit)

  setupZipValidation(
    $('.organization-update-form select[name="stateCode"]'),
    $('.organization-update-form input[name="zipCode"]')
  );


  $('.organization-update-form #org-name-note').removeClass('with-errors');
  $('form.organization-update-form input[name="name"]').unbind('change keyup').bind('change keyup', function(){
    ($(this).val().length>100) && $('.organization-update-form #org-name-note').addClass('with-errors');
  })


  request({
    url: '/fundraisers/organizations/states',
    callback: function (states) {
      $('.organization-update-form select[name="stateCode"] option').remove();
      $.each(states, function (k, state) {
        $('.organization-update-form select[name="stateCode"]').append(
            $('<option>').attr({value: state.code}).text(state.name).data({state: state, country: state.country})
        );
      });
      $('.organization-update-form select[name="stateCode"]').val(organization.stateCode).trigger('change');
    }
  })
  $('.organization-update-form input[name="id"]').val(organization.id);
  $('.organization-update-form input[name="uuid"]').val(organization.uuid);
  if (organization.zipCode) $('.organization-update-form input[name="zipCode"]').val(organization.zipCode);

  $('.organization-update-form .add-new-organization-btn').hide();
  $('.organization-update-form .add-new-event-btn').hide();
  $('.organization-update-form .organization-avatar-fields').hide();
  $('.organization-update-form').validator('validate');
  $('.organization-update-form').removeClass('loading-mask');

  $('.organization-update-form').unbind('change').find('input[name="emailAddressForCheck"], input[name="emailAddress2ForCheck"] ,input[name="city"] ,input[name="zipCode"],select[name="stateCode"]').change(function () {
    $('form.organization-update-form').data({validAdderss: false});
  });
}

function scrollToCurremtElement(el,px){
  $([document.documentElement, document.body]).animate({
    scrollTop: px?el.offset().top+px:el.offset().top
  }, 300);
}

function captchaCallback(key){
  let input = $('input[name="gRecaptcha"]');
  $('textarea#g-recaptcha-response').remove();
  input.val(key);
  setTimeout(function(){
    input.val('');
    grecaptcha.reset();
    input.closest('form').validator('validate');
  }, 120000);
  input.closest('form').validator('validate');
}
function gRecaptchaReset(){
  let input = $('input[name="gRecaptcha"]');
  grecaptcha.reset();
  input.val('');
}
function roundTwoDecimal(numb){
  return (Math.round(numb * 100) / 100).toFixed(2);
}
function getTwoDecimal(numb){
  numb =  numb.toFixed(2).toString().split(".");
  return numb[numb.length-1];
}
function clearInput(el){
  setTimeout(function(){
    $(el).val('');
  },800);
}

function htmlEntities(str) {
  if(str===null) return null;
  else if(str===0) return 0;
  else if(str===undefined) return undefined;
  else return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}

const addTagManager = (properties)=>{
  if(!isUncleTetsu) dataLayer.push(properties);
}

function exportFilesWithPostMethod(cfg){
  $.ajax({
    type: 'POST',
    url: cfg.url,
    contentType: 'application/json',
    data: JSON.stringify(cfg.data || {}),
    xhrFields: {
      responseType: 'blob'
    },
    success: function (data, status, xhr) {
      let filename = 'download.csv';
      const disposition = xhr.getResponseHeader('Content-Disposition');
      if (disposition && disposition.indexOf('attachment') !== -1) {
        const matches = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(disposition);
        if (matches != null && matches[1]) filename = matches[1].replace(/['"]/g, '');
      }
      const url = window.URL.createObjectURL(data);
      const a = document.createElement('a');
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    },
    error: function (xhr, status, error) {
      console.error('Download failed:', error);
    }
  });
}

window.setCookie = setCookie;
window.handleOutboundLinkClicks = handleOutboundLinkClicks;
window.getCookie = getCookie;
window.request = request;
window.onError = onError;
window.getParam = getParam;
window.Validation = Validation;
window.storeValidation = storeValidation;
window.storeValidation2 = storeValidation2;
window.emailValidation = emailValidation;
window.createSuggestor = createSuggestor;
window.fillOrganizationEditForm = fillOrganizationEditForm;
window.fillVfrOganizationEditForm = fillVfrOganizationEditForm;
window.scrollToCurremtElement = scrollToCurremtElement;
window.captchaCallback = captchaCallback;
window.gRecaptchaReset = gRecaptchaReset;
window.roundTwoDecimal = roundTwoDecimal;
window.getTwoDecimal = getTwoDecimal;
window.clearInput = clearInput;
window.htmlEntities = htmlEntities;
window.addTagManager = addTagManager;
window.exportFilesWithPostMethod = exportFilesWithPostMethod;

$.fn.serializeObject=function(){"use strict";let a={},b=function(b,c){let d=a[c.name];"undefined"!=typeof d&&d!==null?$.isArray(d)?d.push(c.value):a[c.name]=[d,c.value]:a[c.name]=c.value};return $.each(this.serializeArray(),b),a};